import { createContext, useContext, useEffect, useState } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

const LenisContext = createContext(null);

export const LenisProvider = ({ children }) => {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({ lerp: 0.08, smoothWheel: true, anchors: false });
    let frame;
    const loop = (time) => {
      instance.raf(time);
      frame = requestAnimationFrame(loop);
    };
    frame = requestAnimationFrame(loop);
    setLenis(instance);
    return () => {
      cancelAnimationFrame(frame);
      instance.destroy();
    };
  }, []);

  return <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>;
};

export const useLenis = () => useContext(LenisContext);

export const useScrollTo = () => {
  const lenis = useLenis();
  return (target, offset = -76) => {
    if (lenis) return lenis.scrollTo(target, { offset, duration: 1.4 });
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  };
};
